import {Component, Input, OnDestroy, OnInit, HostBinding} from '@angular/core';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SceneTooltipCmp'));

// TODO Tooltip interface
@Component({
    selector: 'scene-tooltip-cmp',
    template: require('./scene-tooltip.cmp.html'),
    styles: [String(require('./scene-tooltip.cmp.scss'))],
    host: { 'class': 'scene-tooltip' }
})
export class SceneTooltipCmp {

    @HostBinding('class.view-regions') clickMapIsVisible: boolean = false;

    @Input() product;

    // private _subscriptions: any = {};

    
    constructor () {
        debugOff( 'Construct scene tooltip component' );
    }

    
    ngOnInit() {
        debugOff('Initialise scene tooltip component');
        debugOff( 'Tooltips: ', this.product.tooltips );
    }

    
    ngOnDestroy () {
        debugOff( 'Destruct scene tooltip component' );
    }

    mouseOverTooltip (tooltip) {
        debugOff( 'Mouse over tooltip' );

        // tooltip.Product.TooltipIsHovered = true;
    }

    mouseOutTooltip (tooltip) {
        debugOff( 'Mouse out of tooltip' );

        // tooltip.Product.TooltipIsHovered = false;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/scene/scene-tooltip.cmp.ts